import { userRoles } from "modules/common/constants";
import React, { useContext } from "react";
import { Filter, Checkbox, ToggleSwitch } from "../";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: number[];
}

export type RoleFilterState = string[];

const rolesToRender = [
    userRoles.Citizen,
    userRoles.Farmer,
    userRoles.MinistryOfficial,
    userRoles.MinistryAdviser,
    userRoles.SuperAdmin,
    userRoles.PrivateAdviser,
    userRoles.CommunicatorAdviser,
    userRoles.EquipmentAdmin,
    userRoles.CommunicatorOfficial,
];

export const RoleFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="ULOGA"
        >
            {rolesToRender.map(role => (
                <div key={role.value}>
                    <ToggleSwitch
                        value={role.value.toString()}
                        checked={value.includes(role.value)}
                        onChange={onChange}
                        htmlFor={role.label}
                        text={
                            <div className={lowVision ? "low-vision-white-text" : "filter__item__text"}>
                                {role.label.toLocaleUpperCase()}
                            </div>
                        }
                    />
                </div>
            ))}
        </Filter>
    );
};
